"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var DVBThreeStepsInitStates_1 = require("../../types/enums/DVBThreeStepsInitStates");
var LNBDetectionType_1 = require("../../types/enums/LNBDetectionType");
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.initialState = {
    mwCtxCount: -2,
    isMwReady: false,
    mwEventSource: null,
    scanParams: null,
    playerInstanceId: null,
    hasMail: false,
    isServiceStatusOpen: false,
    isCasErrorModalDisplayed: false,
    scanDvbState: DVBThreeStepsInitStates_1.DVBThreeStepsInitStates.ready,
    isCasHomeSet: DVBThreeStepsInitStates_1.DVBThreeStepsInitStates.ready,
    dvbSignalReservationId: '',
    isPlayerSurfaceSet: DVBThreeStepsInitStates_1.DVBThreeStepsInitStates.ready,
    isPlayerActionDone: false,
    queryRecordingsState: DVBThreeStepsInitStates_1.DVBThreeStepsInitStates.ready,
    isDvbSignalOk: true,
    hasSatelliteConnection: true,
    autoLnbDetectionStatus: LNBDetectionType_1.LNBDetectionStatues.ready,
    isForceScan: false,
    isE016EntitlementError: false,
};
var reducers = (_a = {},
    _a[constants_1.SET_IS_MW_READY] = function (state, action) { return (__assign(__assign({}, state), { isMwReady: action.payload })); },
    _a[constants_1.SET_MW_CTX_COUNT] = function (state, action) { return (__assign(__assign({}, state), { mwCtxCount: action.payload })); },
    _a[constants_1.SET_MW_EVENT_SOURCE] = function (state, action) { return (__assign(__assign({}, state), { mwEventSource: action.payload })); },
    _a[constants_1.SET_SCAN_PARAMS] = function (state, action) { return (__assign(__assign({}, state), { scanParams: action.payload })); },
    _a[constants_1.SET_PLAYER_INSTANCE_ID] = function (state, action) { return (__assign(__assign({}, state), { playerInstanceId: action.payload })); },
    _a[constants_1.SET_SCAN_DVB_STATE] = function (state, action) { return (__assign(__assign({}, state), { scanDvbState: action.payload })); },
    _a[constants_1.SET_HAS_MAIL] = function (state, action) { return (__assign(__assign({}, state), { hasMail: action.payload })); },
    _a[constants_1.SET_IS_SERVICE_STATUS_OPEN] = function (state, action) { return (__assign(__assign({}, state), { isServiceStatusOpen: action.payload })); },
    _a[constants_1.SET_IS_CAS_MODAL_DISPLAYED] = function (state, action) { return (__assign(__assign({}, state), { isCasErrorModalDisplayed: action.payload })); },
    _a[constants_1.SET_IS_E016_ENTITLEMENT_ERROR] = function (state, action) { return (__assign(__assign({}, state), { isE016EntitlementError: action.payload })); },
    _a[constants_1.SET_IS_CAS_HOME_SET] = function (state, action) { return (__assign(__assign({}, state), { isCasHomeSet: action.payload })); },
    _a[constants_1.SET_DVB_RESERVATION_ID] = function (state, action) { return (__assign(__assign({}, state), { dvbSignalReservationId: action.payload })); },
    _a[constants_1.SET_IS_PLAYER_SURFACE_SET] = function (state, action) { return (__assign(__assign({}, state), { isPlayerSurfaceSet: action.payload })); },
    _a[constants_1.SET_PLAYER_ACTION_DONE] = function (state, action) { return (__assign(__assign({}, state), { isPlayerActionDone: action.payload })); },
    _a[constants_1.SET_QUERY_RECORDINGS_STATE] = function (state, action) { return (__assign(__assign({}, state), { queryRecordingsState: action.payload })); },
    _a[constants_1.SET_IS_DVB_SIGAL_OK] = function (state, action) { return (__assign(__assign({}, state), { isDvbSignalOk: action.payload })); },
    _a[constants_1.SET_HAS_SATELLITE_CONNECTION] = function (state, action) { return (__assign(__assign({}, state), { hasSatelliteConnection: action.payload })); },
    _a[constants_1.AUTO_LNB_DETECTION_STATUS] = function (state, action) { return (__assign(__assign({}, state), { autoLnbDetectionStatus: action.payload })); },
    _a[constants_1.SET_FORCE_SCAN] = function (state, action) { return (__assign(__assign({}, state), { isForceScan: action.payload })); },
    _a);
exports.default = toolkit_1.createReducer(exports.initialState, reducers);
//# sourceMappingURL=reducer.js.map